import { createContext } from 'react';

import { ViewAsUser } from './store';

export type ViewAsContextValue = {
  viewAsUser: ViewAsUser | null;
  isViewingAs: boolean;
  enterViewAs: (user: ViewAsUser) => Promise<void>;
  exitViewAs: () => Promise<void>;
};

export const ViewAsContext = createContext<ViewAsContextValue | null>(null);
